import type { ExperienceMode } from '@fetmode/types';

export function homePathForMode(mode: ExperienceMode): string {
  if (mode === 'COMMUNITY') {
    return '/community';
  }
  if (mode === 'VIDEOS') {
    return '/videos';
  }
  return '/cams';
}
